import React, { PureComponent } from 'react';
import { Redirect } from 'react-router-dom';
import { reduxForm } from 'redux-form';
import EyeIcon from 'mdi-react/EyeIcon';
import KeyVariantIcon from 'mdi-react/KeyVariantIcon';
import AccountOutlineIcon from 'mdi-react/AccountOutlineIcon';

import Login from '../../../services/LoginService';
import Alert from '../../../shared/components/Alert';

class LogInForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
      username: '',
      password: '',
      redirectToReferrer: false,
      error: '',
    };
    this.onChange = this.onChange.bind(this);
    this.login = this.login.bind(this);
    this.showPassword = this.showPassword.bind(this);
    this.autoLogin = this.autoLogin.bind(this);
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  login() {
    const { username, password } = this.state;
    const formdata = {
      username,
      password,
    };

    if (username && password) {
      Login.loginAuth(formdata).then(response => (response)).then((result) => {
        const responseJson = result;
        this.setState({ error: '' });
        if (responseJson) {
          if (responseJson !== false) {
            localStorage.setItem('userData', JSON.stringify(responseJson));
            this.setState({ redirectToReferrer: true, error: '' });
          } else {
            this.setState({ error: 'Invalid username/password!' });
          }
        } else {
          this.setState({ error: 'Invalid username/password!' });
        }
      }).catch((error) => {
        console.log(error);
      });
    } else {
      this.setState({ error: 'Must fill in form' });
    }
  }

  showPassword(e) {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  }

  autoLogin(e, user, pass) {
    e.preventDefault();
    const dis = this;
    this.setState({ username: user, password: pass });
    setTimeout(() => {
      dis.login();
    }, 10);
  }

  render() {
    const {
      showPassword, redirectToReferrer, error, username, password,
    } = this.state;

    if (redirectToReferrer || localStorage.getItem('userData') !== null) {
      const userdata = JSON.parse(localStorage.getItem('userData'));
      let path = '/dashboard';
      if (userdata.type === '2') {
        path = `/inventory/warehouse/dashboard/${userdata.location_id}`;
      } else if (userdata.type === '3') {
        path = `/inventory/logistic/dashboard/${userdata.location_id}`;
      }
      return (<Redirect push to={path} />);
    }

    return (
      <div>
        <div className="login-buttons">
          <button type="button" className="btn btn-primary btn-block login-select m-0 m-b-10" onClick={e => this.autoLogin(e, 'admin', 'admin')}>Admin</button>
          <button type="button" className="btn btn-primary btn-block login-select m-0 m-b-10" onClick={e => this.autoLogin(e, 'office', 'office')}>Office</button>
          <button type="button" className="btn btn-primary btn-block login-select m-0 m-b-10" onClick={e => this.autoLogin(e, 'purchaser', 'purchaser')}>Purchaser</button>
          <button type="button" className="btn btn-primary btn-block login-select m-0 m-b-10" onClick={e => this.autoLogin(e, 'warehouse', 'warehouse')}>Warehouse</button>
          <button type="button" className="btn btn-primary btn-block login-select m-0 m-b-10" onClick={e => this.autoLogin(e, 'logistic', 'logistic')}>Logistic</button>
          <button type="button" className="btn btn-primary btn-block login-select m-0 m-b-10" onClick={e => this.autoLogin(e, 'store', 'store')}>Retail Store</button>
        </div>

        <form className="form display-none" onSubmit={this.login} id="login_form">
          {error && (
            <div className="notif_msg">
              <Alert color="danger" className="alert--colored">
                <p><span className="fa fa-exclamation">&nbsp;</span> {error}</p>
              </Alert>
            </div>
          )
          }
          <div className="form__form-group">
            <span className="form__form-group-label fs-15 bold">Username</span>
            <div className="form__form-group-field form-input-x2">
              <div className="form__form-group-icon">
                <AccountOutlineIcon />
              </div>
              <input type="text" name="username" value={username} onChange={this.onChange} />
            </div>
          </div>
          <div className="form__form-group m-b-35">
            <span className="form__form-group-label fs-15 bold">Password</span>
            <div className="form__form-group-field form-input-x2">
              <div className="form__form-group-icon">
                <KeyVariantIcon />
              </div>
              <input type={showPassword ? 'text' : 'password'} name="password" value={password} onChange={this.onChange} />
              <button
                type="button"
                className={`form__form-group-button${showPassword ? ' active' : ''}`}
                onClick={e => this.showPassword(e)}
              ><EyeIcon />
              </button>
            </div>
          </div>
          <div className="account__btns m-0">
            <button type="submit" className="btn btn-primary account__btn submit-btn">Login</button>
            {/* <Link className="btn btn-primary account__btn" to="/home">Log In</Link> */}
          </div>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'log_in_form', // a unique identifier for this form
})(LogInForm);
